module.exports = __webpack_public_path__ + "assets/node_modules/leaflet/dist/images/layers-2x.png?0_6320c4";